// 藥櫃清單
// 藥櫃點開會顯示 ADCDetail.vue

<template lang="pug">
  div
    h6 藥櫃清單
    vuetable(ref="vuetable"
    :api-url="`${server}/api/system/?type=ADC`"
    data-path="results"
    pagination-path=""
    :fields="fields"
    :api-mode="true"
    :css="boostrapCss"
    :http-options="httpOptions"
    detail-row-component="adc-detail"
    @vuetable:cell-clicked="onCellClicked")
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import ADCDetail from './ADCDetail';

Vue.component('adc-detail', ADCDetail);
// 顯示系統藥盒數量及抽屜量
Vue.component('count-device', {
  name: 'CountDevice',
  props: [
    'rowData', 'rowIndex', 'rowField',
  ],
  template: `
  <span>{{ rowData.net_count }} / {{ rowData.device_count }}</span>`,
});


export default {
  name: 'ADCList',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        {
          name: 'name',
          title: '名稱',
        },
        {
          name: 'area.name',
          title: '所屬區域',
        },
        {
          name: 'area.department.name',
          title: '所屬單位',
        },
        {
          name: 'admin.username',
          title: '管理者',
        },
        {
          name: '__component:count-device',
          title: '抽屜數量 / 藥盒數量',
        },
      ],
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
  },
  methods: {
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    drawerCount(netSet) {
      const dCount = netSet.length;
      let bCount = 0;
      netSet.forEach((net) => {
        net.device_set.forEach((item) => {
          bCount += 1;
        });
      });
      return `${dCount} / ${bCount}`;
    },
  },
};
</script>




// WEBPACK FOOTER //
// ADCList.vue?568bca8e